import React from "react";
import { TextField, Box } from "@mui/material";

function CashForm({ cashInfo, setCashInfo }) {
  // Funzione per gestire i cambiamenti negli input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCashInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value, // Aggiorna il campo corretto in base al nome
    }));
  };

  // Funzione per formattare il numero della carta
  const handleCardNumberChange = (e) => {
    const input = e.target.value.replace(/\D/g, ""); // Rimuove tutti i caratteri non numerici
    const formattedValue = input.replace(/(.{4})/g, "$1 ").trim(); // Inserisce due spazi ogni 4 caratteri

    // Aggiorna il valore nel tuo stato (es. cashInfo)
    setCashInfo((prevInfo) => ({
      ...prevInfo,
      cardNumber: formattedValue, // Aggiorna direttamente il campo cardNumber
    }));
  };

  const handleExpiryChange = (e) => {
    const input = e.target.value.replace(/\D/g, ""); // Rimuove tutti i caratteri non numerici
    let formattedValue = "";

    if (input.length > 2) {
      formattedValue = `${input.slice(0, 2)}/${input.slice(2, 4)}`; // Aggiunge uno slash dopo i primi 2 caratteri
    } else {
      formattedValue = input; // Mostra solo i numeri inseriti se sono meno di 2
    }

    // Aggiorna il valore nel tuo stato (es. cashInfo)
    setCashInfo((prevInfo) => ({
      ...prevInfo,
      expiryDate: formattedValue, // Aggiorna direttamente il campo expiryDate
    }));
  };

  return (
    <Box>
      <TextField
        required
        fullWidth
        label="Name"
        name="name"
        value={cashInfo.name}
        onChange={handleChange}
      />
      <TextField
        required
        fullWidth
        label="Card Number"
        name="cardNumber"
        value={cashInfo.cardNumber}
        onChange={handleCardNumberChange} // Usa la funzione di cambio personalizzata
        inputProps={{ maxLength: 19 }} // Limita la lunghezza massima a 19 caratteri (16 cifre + 3 spazi)
      />
      <TextField
        required
        fullWidth
        label="Expiry Date (MM/YY)"
        name="expiryDate"
        value={cashInfo.expiryDate}
        onChange={handleExpiryChange}
        inputProps={{ maxLength: 5 }} // Limita la lunghezza massima a "MM/YY"
      />
      <TextField
        required
        fullWidth
        label="CVV"
        name="cvv"
        type="password" // Usa type="password" per sicurezza
        value={cashInfo.cvv}
        onChange={handleChange}
      />
    </Box>
  );
}

export default CashForm;
